import { render, staticRenderFns } from "./AccountBadge.vue?vue&type=template&id=a9e27d38&scoped=true"
import script from "./AccountBadge.vue?vue&type=script&lang=js"
export * from "./AccountBadge.vue?vue&type=script&lang=js"
import style0 from "./AccountBadge.vue?vue&type=style&index=0&id=a9e27d38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e27d38",
  null
  
)

export default component.exports